module.exports = __webpack_public_path__ + "img/3.3-klein.28207e41.png";